








































import Vue from "vue";
import { Component, Ref } from "vue-property-decorator";
import User from "@/models/user";
import IChangeEmailRequestModel from "@/interfaces/change-email-request-model";
import { mapState } from "vuex";

@Component({
  computed: {
    ...mapState("authentication", ["user"]),
  },
})
export default class Email extends Vue {
  // mapState
  user!: User;

  loading = false;
  success = false;

  @Ref("emailFormRef")
  emailFormRef!: any;

  emailForm: any = {
    email: "",
    currentPassword: "",
  };

  checkEmail = (rule: any, value: any, callback: any) => {
    if (!value) {
      return callback(new Error("Your email address is required"));
    } else {
      // check if the mail is valid
      const regExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!regExp.test(String(value).toLowerCase())) {
        return callback(new Error("Please enter a valid email address"));
      } else {
        this.$store
          .dispatch("authentication/checkEmailExists", this.emailForm.email)
          .then(
            () => {
              return callback();
            },
            () => {
              return callback(new Error("Email already exists"));
            }
          );
      }
    }
  };

  rules: any = {
    email: [
      {
        validator: this.checkEmail,
        required: true,
        trigger: ["blur"],
      },
    ],
    currentPassword: [
      {
        required: true,
        message: "Your password is required",
        trigger: ["blur"],
      },
    ],
  };

  changeEmail() {
    this.emailFormRef.validate((valid: boolean) => {
      if (valid) {
        this.loading = true;

        const model: IChangeEmailRequestModel = {
          currentPassword: this.emailForm.currentPassword,
          email: this.emailForm.email,
          userId: this.user.id,
        };

        this.$store.dispatch("authentication/changeEmail", model).then(
          () => {
            this.loading = false;
            this.$message({
              message:
                "A confirmation has been send to your new email address.",
              type: "success",
            });
          },
          () => {
            this.loading = false;
            this.$message({
              message:
                "Something went wrong while changing your email address. Please try again.",
              type: "error",
            });
          }
        );
      }
    });
  }
}
